interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  icon?: React.ReactNode;
}

export function EmptyState(props: EmptyStateProps) {
  const { title, description, action, icon } = props;
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-brand-200 bg-white px-6 py-12 text-center">
      {icon && <div className="mb-3 text-brand-300">{icon}</div>}
      <h3 className="text-base font-semibold text-brand-900">{title}</h3>
      {description && <p className="mt-1.5 max-w-sm text-sm text-brand-500">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
